import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./DriveAuth.css";

export default function DriveAuth() {
  const navigate = useNavigate();
  const [authUrl, setAuthUrl] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [done, setDone] = useState(false);

  // 🔹 Paso 1: obtener la URL de autorización
  useEffect(() => {
    const fetchAuthUrl = async () => {
      try {
        const res = await fetch(
          "https://te-ayudo.es/back/api/google/generate_token.php",
          {
            credentials: "include",
            headers: { Accept: "application/json" },
          }
        );

        const data = await res.json();
        if (data.ok && data.auth_url) {
          setAuthUrl(data.auth_url);
        } else {
          setMessage("⚠️ Error al obtener la URL de autorización.");
        }
      } catch (err) {
        console.error("❌ Error al obtener auth URL:", err);
        setMessage("❌ No se pudo conectar con el servidor.");
      } finally {
        setLoading(false);
      }
    };

    fetchAuthUrl();
  }, []);

  // 🔹 Paso 2: guardar el token con el código proporcionado
  const handleSave = async () => {
    if (!code.trim()) {
      alert("Introduce el código de autorización que te dio Google.");
      return;
    }

    setMessage("Guardando token...");
    try {
      const formData = new FormData();
      formData.append("code", code.trim());

      const res = await fetch("https://te-ayudo.es/back/api/google/save_token.php", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (data.ok) {
        setMessage(
          "✅ Token guardado correctamente. Ya puedes usar Google Drive."
        );
        setDone(true);
      } else {
        throw new Error(data.error || "Error desconocido al guardar el token.");
      }
    } catch (err) {
      console.error("❌ Error al guardar token:", err);
      setMessage("❌ " + err.message);
    }
  };

  return (
    <div className="drive-auth-container">
      <h2>🔑 Autenticación con Google Drive</h2>

      {loading ? (
        <p>Cargando enlace de autorización...</p>
      ) : (
        <>
          {authUrl && !done && (
            <>
              <p>
                1️⃣ Haz clic en el siguiente enlace para autorizar a la
                aplicación:
              </p>
              <a
                href={authUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="drive-link"
              >
                Autorizar con Google
              </a>

              <p style={{ marginTop: "1rem" }}>
                2️⃣ Copia el código que te muestra Google y pégalo aquí:
              </p>
              <input
                type="text"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Pega aquí el código de autorización"
                className="drive-input"
              />

              <button onClick={handleSave} className="drive-btn">
                Guardar token
              </button>
            </>
          )}

          {done && (
            <>
              <p style={{ color: "green", fontWeight: "bold" }}>
                ✅ Token guardado correctamente.
              </p>
              <button
                className="drive-btn back-btn"
                onClick={() => navigate(-1)} // 🔙 vuelve al dashboard anterior
              >
                ← Volver al Dashboard
              </button>
            </>
          )}

          {message && <p className="drive-message">{message}</p>}
        </>
      )}
    </div>
  );
}
